import { type GameAward } from '@terros/common'

export const findNextPlace = (awards: GameAward[], skipEmptyPlaces: boolean): number => {
  for (let i = 0; i < awards.length; i++) {
    const place = i + 1
    const award = awards.at(i)
    if (!award) return place
    if (award.place !== place) {
      if (!skipEmptyPlaces) return place
    }
  }

  if (!skipEmptyPlaces) {
    return awards.length + 1
  }

  const lastAward = awards.at(-1)
  if (!lastAward) return 1
  return lastAward.place + 1
}

export const stringifyPlace = (place: number): string => {
  if (place <= 0) return place.toString()
  const suffix = getPlacementSuffix(place)
  return `${place}${suffix}`
}

export const getPlacementSuffix = (place: number): string => {
  const lastDigit = place % 10
  const lastTwoDigits = place % 100

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return 'th'
  }

  switch (lastDigit) {
    case 1:
      return 'st'
    case 2:
      return 'nd'
    case 3:
      return 'rd'
    default:
      return 'th'
  }
}

export const sortAwardsByPlace = (a: Pick<GameAward, 'place'>, b: Pick<GameAward, 'place'>): number => {
  return a.place - b.place
}
